import type { VFC } from 'react';

import { useTranslation } from 'react-i18next';

import { Badge } from '../Badge/Badge';

export const SimpleLiveBadge: VFC = () => {
  const { t } = useTranslation();

  return <Badge kind="live" label={t('Live')} />;
};
